import Vue from 'vue'
import Router from 'vue-router'
import User from './user'
import Advice from './advice'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/home'),
      meta: { anonymous: true }
    },
    ...User,
    ...Advice
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js